const RANK = { urgente: 0, alta: 1, media: 2, bassa: 3 };

const byPriority = (a, b) =>
  (RANK[a.priority] ?? 2) - (RANK[b.priority] ?? 2) ||
  (a.time || "").localeCompare(b.time || "") ||
  (a.created_at || "").localeCompare(b.created_at || "");

// Tasks never moved by hand come first by priority, then the hand-ordered ones
export const sortTasks = (tasks) => [
  ...tasks.filter((t) => t.position == null).sort(byPriority),
  ...tasks.filter((t) => t.position != null).sort((a, b) => a.position - b.position),
];

export const isManual = (tasks) => tasks.some((t) => t.position != null);
